import { FeedbackType } from './shared/enums/feedback-type.enum';
import { CorrectFeedback } from './models/feedback/correct-feedback.model';
import { Feedback } from './models/feedback/feedback.model';
import { InCorrectFeedback } from './models/feedback/incorrect-feedback.model';
import { InformationalFeedback } from './models/feedback/informational-feedback.model';
import { SelfCheckFeedback } from './models/feedback/self-check-feedback.model';

export class FeedbackMapper {
  private static readonly mappers: Record<string, (dto: any) => Feedback> = {
    [FeedbackType.CORRECT]: CorrectFeedback.fromDto,
    [FeedbackType.INCORRECT]: InCorrectFeedback.fromDto,
    [FeedbackType.INFORMATIONAL]: InformationalFeedback.fromDto,
    [FeedbackType.SELF_CHECK]: SelfCheckFeedback.fromDto,
  };

  public static fromDto(dto: any): Feedback {
    const mapper: ((dto: any) => Feedback) | undefined =
      FeedbackMapper.mappers[dto.type];
    if (!mapper) {
      throw new Error(`Unknown feedback type: ${dto.type}`);
    }
    return mapper(dto);
  }
}
